import styled from 'styled-components'
import { mediaQueries } from 'plugins/device'
import {
  Modal as BuiModal,
  TextBody,
  TextHeadline2,
  TextCallout2,
  TextCaption1,
  TextArea,
  Button,
  IconIllustrativeOk as BuiIconIllustrativeOk,
  IconIllustrativeInfo as BuiIconIllustrativeInfo,
  Link as BuiLink,
  IconRight as BuiIconRight,
  IconClose,
  colors,
} from '@blocket/blocket-ui'

export const Modal = styled(BuiModal)`
  padding: 0;
  @media ${mediaQueries.medium} {
    max-width: 400px;
    min-height: 550px;
    padding: 16px;
    border-radius: 12px;
  }
`

export const ModalHeader = styled.div`
  position: relative;
  margin-bottom: 16px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid ${colors.grey400};

  @media ${mediaQueries.medium} {
    margin-bottom: 32px;
    height: auto;
    border-bottom: none;
    align-items: flex-start;
  }
`

export const ModalHeaderText = styled(TextBody)`
  padding: 10px;
  position: absolute;
  right: 4px;
  top: 2px;
  bottom: 0;
`

export const ModalContent = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  @media ${mediaQueries.medium} {
    padding: 0;
  }
`

export const ModalContentHeading = styled(TextHeadline2)`
  margin-bottom: 10px;
  @media ${mediaQueries.medium} {
    text-align: center;
  }
`

export const InfoWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  @media ${mediaQueries.medium} {
    align-self: center;
  }
`

export const InfoText = styled(TextCallout2)`
  margin-left: 8px;
  color: ${colors.grey700};
`

export const PillWrapper = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  @media ${mediaQueries.medium} {
    margin-bottom: 8px;
  }
`

export const Pill = styled.div`
  margin-bottom: 16px;
  margin-right: 16px;
  padding: 8px 16px;
  border-radius: 24px;
  background: ${({ active }) => (active ? colors.blue600 : colors.grey200)};
  color: ${({ active }) => (active ? colors.white100 : colors.grey800)};
  &:hover {
    cursor: pointer;
  }
`

export const DescriptionForm = styled.form`
  display: flex;
  flex-direction: column;
`

export const DescriptionHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
`

export const DescriptionHeading = styled(TextHeadline2)`
  margin-right: 10px;
`

export const DescriptionText = styled(TextBody)`
  margin-top: 3px;
  color: ${colors.grey500};
`

export const DescriptionInfo = styled(TextBody)`
  margin-bottom: 16px;
`

export const DescriptionTextArea = styled(TextArea)`
  margin-bottom: 16px;
  height: 160px;
  div {
    background: transparent;
  }
  div > textarea {
    resize: none;
  }
  @media ${mediaQueries.medium} {
    height: 110px;
  }
`

export const ThankYouHeading = styled(TextHeadline2)`
  margin-bottom: 8px;
  @media ${mediaQueries.medium} {
    text-align: center;
  }
`

export const ThankYouText = styled(TextBody)`
  margin-bottom: 16px;
  @media ${mediaQueries.medium} {
    text-align: center;
  }
`

export const InfoBox = styled.div`
  margin-bottom: 32px;
  padding: 16px;
  display: flex;
  background: ${colors.blue50};
  border-radius: 6px;
`

export const InfoBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const InfoBoxText = styled(TextCallout2)`
  margin-bottom: 8px;
  max-width: 271px;
`

export const Link = styled(BuiLink)`
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 20px;
  &:hover {
    cursor: pointer;
    svg {
      opacity: 0.8;
    }
  }
`

export const CloseButton = styled(Button)`
  width: 148px;
  @media ${mediaQueries.medium} {
    margin: 0 auto;
    width: 128px;
  }
`

export const CloseIcon = styled(IconClose)`
  position: absolute;
  top: 6px;
  right: 8px;
  &:hover {
    cursor: pointer;
  }
  @media ${mediaQueries.medium} {
    top: -8px;
    right: -8px;
  }
`

export const SubmitButton = styled(Button)`
  @media ${mediaQueries.medium} {
    width: 196px;
    margin-bottom: 8px;
  }
`
export const GeneralErrorText = styled(TextCaption1)`
  color: ${colors.yellow900};
`

export const IconIllustrativeOk = styled(BuiIconIllustrativeOk)`
  margin-bottom: 24px;
  @media ${mediaQueries.medium} {
    margin: 0 auto;
    margin-bottom: 24px;
  }
`

export const IconIllustrativeInfo = styled(BuiIconIllustrativeInfo)`
  margin-right: 16px;
  min-width: 24px;
`

export const IconRight = styled(BuiIconRight)`
  margin-left: 4px;
`
